import React from 'react'
import HomePageBanner from '../Components/HomePageBanner'
import AIA from "../Components/AIA"
import axios from 'axios'
import { useParams } from 'react-router-dom'


const SectionHome = () => {    
    const { title } = useParams();
    const [isLoading, setLoading] = React.useState(false)
    const [data, setData ] = React.useState({
        featured: [],
        trending: [],
        top_stories: [],
        recent: []
    })

    const getNewsData = (title) => {
    const url = `https://jtimes.zuddo.biz/main/api/storysection/${title.toLowerCase()}`
    axios.get(url)
        .then(res => {
        setData(res.data.data);
        setLoading(false)
        })
        .catch(err => {
        console.error('Error fetching stories:', err)
        setLoading(false)
        })
    }

    React.useEffect(() => {
    getNewsData(title);
    }, [title]);
    

    return (
        isLoading ? (
            <div style={{margin:"10px 40%"}}> 
                <img style={{margin:"auto"}} width="300px" height="300px" src="https://www.bluechipexterminating.com/wp-content/uploads/2020/02/loading-gif-png-5.gif" alt="loading"/> 
            </div>
        ) : (
            <div style={{marginTop:"0px"}}>
                <div>      
                    {data?.featured.length >0 ?
                    <HomePageBanner data={data.featured}/>:
                    (<div></div>)
                    }        
                              
                </div>
                <div style={{ padding:'0', borderTop:'3px solid',  width:"91%", margin:"10px auto"}}></div>
                                {data.trending.length > 0 && (
                                    <div style={{marginTop: "30px"}}>
                                        <h2 style={{padding: "0 40px", marginBottom: "20px"}}>Trending Now</h2>
                                        {data.trending.map((article, idx) => (
                                            <AIA
                                                key={article.id || idx}
                                                data={article}
                                                imgUrl={article?.multimedia?.[0]?.url}
                                                imgCaption={article?.multimedia?.[0]?.caption}
                                            />
                                        ))}
                                    </div>
                                )}
                                
                                <div style={{ padding:'0', borderTop:'3px solid',  width:"91%", margin:"10px auto"}}></div>
                                
                         
                                {data.top_stories.length > 0 && (
                                    <div style={{marginTop: "30px"}}>
                                        <h2 style={{padding: "0 40px", marginBottom: "20px"}}>Top Stories</h2>
                                        {data.top_stories.map((article, idx) => (
                                            <AIA
                                                key={article.id || idx}
                                                data={article}
                                                imgUrl={article?.multimedia?.[0]?.url}
                                                imgCaption={article?.multimedia?.[0]?.caption}
                                            />
                                        ))}
                                    </div>
                                )}
                                
                                <div style={{ padding:'0', borderTop:'3px solid',  width:"91%", margin:"10px auto"}}></div>
                                
                             
                                {data.recent.length > 0 && (
                                    <div style={{marginTop: "30px"}}>
                                        <h2 style={{padding: "0 40px", marginBottom: "20px"}}>Recent News</h2>
                                        {data.recent.map((article, idx) => (
                                            <AIA
                                                key={article.id || idx}
                                                data={article}
                                                imgUrl={article?.multimedia?.[0]?.url}
                                                imgCaption={article?.multimedia?.[0]?.caption}
                                            />
                                        ))}
                                    </div>
                                )}
                
            </div>
        )
    )
}

export { SectionHome }